import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import { SEO } from '../../core/seo/seo-paginas';
import { SeoService } from '../../core/services/seo.service';
import { LocaleService } from '../../core/services/locale.service';

@Component({
    selector: 'app-page404',
    templateUrl: './page404.component.html',
    styleUrls: ['./page404.component.scss'],
    imports: [LottieComponent, RouterLink, TranslocoModule]
})

/**
 * Page404 Component
 */
export class Page404Component implements OnInit {

  constructor(
    private readonly seo: SeoService,
    public readonly locale: LocaleService,
    private readonly transloco: TranslocoService,
  ) { }

  ngOnInit(): void {
    this.seo.apply({
      title: this.transloco.translate(SEO.page404.titleKey),
      description: this.transloco.translate(SEO.page404.descriptionKey),
      robots: SEO.page404.robots,
    });
  }

  options: AnimationOptions = {
    path: 'assets/json/animation-car-finder-404.json',
  };

  animationCreated(_animationItem: AnimationItem): void { }

}
